// extracted by mini-css-extract-plugin
export default {"imageCredit":"ImageCredit_imageCredit__Jp9CJ"};